export class InvoiceNoteDto {
    noteText = '';
    userCode = '';
    id = 0;
    orderId = 0;
    createdDate: Date | null = null;
  
    // Properties required by SPA
    userName = '';
    isEditEnabled=false;
    isTruncated = false;
  }